export default __webpack_public_path__ + "static/media/checkmark-icon.f93119d1.svg";